import React from 'react';
import { Field, Spinner } from '../Common'

export default class MemoryChargedResetPasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            code: '',
            errorPassword: '',
            errorConfirmPassword: '',
            displayPassword: false,
            displayConfirmPassword: false,
            errorCode: ''
        }
    }

    handleOnChange(key, e) {
        let value = e.target.value;
        this.validForm(key, value);
        this.setState(() => ({ [key]: value }));
    }



    toggleDisplayPassword = (key) => {
        this.setState(prevState => ({ [key]: !prevState[key] }));
    }

    validForm = (key, value) => {
        let errorConfirmPassword
        if (key === "password") {
            errorConfirmPassword = value != this.state.confirmPassword ? ' is-invalid' : '';
            this.setState(() => ({ errorConfirmPassword }));
        }
        if (key === "confirmPassword") {
            errorConfirmPassword = value != this.state.password ? ' is-invalid' : '';
            this.setState(() => ({ errorConfirmPassword }));
        }
    }

    isDisableButton = () => {
        return !this.state.password ||
            !this.state.confirmPassword ||
            !this.state.code ||
            this.state.errorConfirmPassword
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit({
            password: this.state.password,
            code: this.state.code
        })
    }

    render() {
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <Field
                            type={this.state.displayPassword ? 'text' : 'password'}
                            label="Mot de passe *"
                            _className={"form-control  " + this.state.errorPassword}
                            error={this.state.errorPassword}
                            autoFocus
                            value={this.state.password}
                            onChange={this.handleOnChange.bind(this, 'password')}
                        />
                        <div className="icon" onClick={() => this.toggleDisplayPassword('displayPassword')} ></div>
                    </div>
                    <div className="form-group">
                        <Field
                            type={this.state.displayConfirmPassword ? 'text' : 'password'}
                            label="Confirmation du mot de passe *"
                            _className={"form-control  " + this.state.errorConfirmPassword}
                            error={this.state.errorConfirmPassword}
                            autoFocus
                            value={this.state.confirmPassword}
                            onChange={this.handleOnChange.bind(this, 'confirmPassword')}
                            errorMessage=" "
                        />
                        <div className="icon" onClick={() => this.toggleDisplayPassword('displayConfirmPassword')} ></div>
                    </div>
                    <Field
                        type="text"
                        label="Code d'activation *"
                        _className={"form-control  " + this.state.errorCode}
                        error={this.state.errorCode}
                        autoFocus
                        value={this.state.code}
                        onChange={this.handleOnChange.bind(this, 'code')}
                    />


                    <div className="required-txt"> * Champs obligatoires</div>
                    <div className="button-container">
                        <button type="submit" className={`btn btn-primary btn-lg spinner-${this.props.spinner}`} disabled={this.isDisableButton()} >
                            <span>ENVOYER</span>
                            <Spinner status={this.props.spinner} />
                        </button >
                    </div>
                </form>
                <div className="bloc-form_error">
                    {this.state.errorMessage &&
                        <div className="alert alert-danger" role="alert">
                            {this.state.errorMessage}
                        </div>
                    }
                </div>
            </div>
        )
    }

}





// WEBPACK FOOTER //
// ./src/components/MemoryChargedLoginPage/MemoryChargedResetPasswordForm.js